export default __webpack_public_path__ + "static/media/download.2b3d7bb9.svg";